import Base from '../base';
import apiUrls from '../api-urls';

export default class CurrencyAPI extends Base {
    async load() {
        return this.apiClient.get(apiUrls.customers.customerCurrency);
    }
}
